import Service from "../../../Services/index";
import moment from "moment";

const Receivable = {
    namespaced: true,
    state: {
        receivables: null,
        checkbox_id: [],
        receivables_all: null,
        search: {
            date: [],
            customer_id: "",
            sale_id: "",
            sale: "",
            customer: "",
            action: "",
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
    },
    mutations: {
        SET_RECEIVABLES: (state, res) => {
            // //console.log(res)
            state.receivables = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.from,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
            // let _ = require('lodash');
            // let receivables = _.groupBy(res.data,'customer_id');
            // for (const key of Object.keys(receivables)) {
            //     let invoices = receivables[key];
            //     let sum_total = invoices.reduce(function(carry, order){
            //         return order.remaining_payoff + carry
            //     },0);
            //     receivables[key] = {
            //         invoices,
            //         sum_total
            //     }
            // }
        },
        SET_SEARCH: (state, search) => {
            state.search = {
                ...search
            }
        },
        SET_CHECKBOX: (state, data) => {
            state.checkbox_id = [];
            if (state.receivables_all) {
                state.receivables_all.forEach(receivable => {
                    receivable.invoices.filter(invoice => data.includes(invoice.id)).forEach(invoice => {
                        invoice.active = true;
                    })
                    receivable.invoices.filter(invoice => !data.includes(invoice.id)).forEach(invoice => {
                        invoice.active = false;
                    })
                })
            }
            state.checkbox_id = data;
        },
        SET_ALL: (state, data) => {
            localStorage.clear();
            state.receivables_all = [];
            state.receivables_all = data;
        },
        FIRST_LOAD: (state) => {
            state.receivables_all = state.receivables;
        },
        CLEAR_SEARCH: (state) => {
            state.search = {
                date: [],
                customer_id: "",
                sale_id: '',
                sale: "",
                customer: "",
                action: "",
            };
        },
    },
    actions: {
        setReceivables({commit}, {page, search}) {
            let start_date = "";
            let end_date = "";
            if (search.date.length > 0) {
                if (search.date[0] && search.date[1]) {
                    start_date = moment(search.date[0]).format("YYYY-MM-DD");
                    end_date = moment(search.date[1]).format("YYYY-MM-DD");
                }
            }
            let data = {
                start_date: start_date,
                end_date: end_date,
                customer_id: search.customer_id,
                sale_id: search.sale_id,
                action: search.action
            };
            return Service.ReceivableSellers.getReceivableBySeller(page, data).then(res => {
                commit("SET_RECEIVABLES", res);
            })
        },
        setSearch({commit}, search) {
            commit("SET_SEARCH", search)
        },
        getAll({commit}, {page, search}) {
            let start_date = "";
            let end_date = "";
            if (search.date.length > 0) {
                if (search.date[0] && search.date[1]) {
                    start_date = moment(search.date[0]).format("YYYY-MM-DD");
                    end_date = moment(search.date[1]).format("YYYY-MM-DD");
                }
            }
            let data = {
                start_date: start_date,
                end_date: end_date,
                customer_id: search.customer_id,
                sale_id: search.sale_id,
                action: search.action
            };
            return Service.ReceivableSellers.getReceivableBySeller(page, data).then(res => {
                commit("SET_ALL", res);
                return res;
            });
        },
        firstLoad({commit}) {
            commit("FIRST_LOAD");
        },
        clearSearch({commit}) {
            commit("CLEAR_SEARCH");
        },
        setCheckbox({commit}, data) {
            commit("SET_CHECKBOX", data);
        },
        getCustomerFromSale({commit}, sale_id) {
            return Service.ReceivableSellers.getCustomerFromSale(sale_id)
        },
    }
};

export default Receivable
